import { z } from 'zod';
import { BaseLevel, baseLevelSchema } from './levels';
import type { ExtendedBaseUser } from './users';

export const packLevel = baseLevelSchema.extend({
    completed_by_user: z.boolean().optional(),
});
export type PackLevel = z.infer<typeof packLevel>;

export const basePackSchema = z.object({
    id: z.uuidv4(),
    name: z.string().min(1).max(200),
});

export type BasePack = z.infer<typeof basePackSchema>;

export const packSchema = basePackSchema.extend({
    points: z.number().min(0),
    levels: z.array(packLevel),
});
export type Pack = z.infer<typeof packSchema>;

export const basePackTierSchema = z.object({
    id: z.uuidv4(),
    name: z.string().min(1).max(100),
    color: z.string().min(1).max(300),
});
export type BasePackTier = z.infer<typeof basePackTierSchema>;

export const packTierSchema = basePackTierSchema.extend({
    placement: z.number().min(1),
    packs: z.array(packSchema),
});
export type PackTier = z.infer<typeof packTierSchema>;

// Used to display the packs a level is part of on the list page
export type LevelPack = BasePack & {
    tier: BasePackTier;
};

export interface ProfilePack extends LevelPack {
    points?: number;
    levels?: BaseLevel[];
}

export type PackCompletion = {
    user: ExtendedBaseUser;
    completed_at: string;
};
